import DPDropDown from "framework/components/DPDropDown";
import DPTextBox from "framework/components/DPTextBox";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "reactstrap";


const JournalViewContent = ({ invoiceText, formData, setFormData, SearchFiles, getFileData }) => {

    const [searchTerm, setSearchTerm] = useState("");
    const [lines, setLines] = useState([]);
    const containerRef = useRef(null);


    useEffect(() => {


        if (invoiceText == "") {
            setLines([])
            setSearchTerm("")
            return
        };
        const lines = invoiceText.split("\n");
        const processedLines = [];
        for (let line of lines) {
            // Check if this line is exactly the delimiter
            if (line.trim() === "##########################################") {
                // Add 2 blank lines above
                processedLines.push("_");
                processedLines.push("_");
                // Add the delimiter line
                processedLines.push(line);
                // Add 2 blank lines below
                processedLines.push("_");
                processedLines.push("_");
            } else {
                // Just add the normal line
                processedLines.push(line);
            }
        }

        setLines(processedLines);

    }, [invoiceText]);


    const handleSearch = () => {
        if (!searchTerm) return;
        // Find the first line index that contains the search term
        const index = lines.findIndex((line) =>
            line.includes(searchTerm)
        );
        if (index !== -1) {
            // Scroll that line into view
            const element = document.getElementById(`line-${index}`);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    };


    return (
        <div>
            <div style={{ marginBottom: "10px" }}>
                <Row>
                    <Col sm={12} md={3} className="mb-4-sm">
                        <DPTextBox
                            rowClass="mb-3-sm"
                            labelText="Select Date"
                            textType="date"
                            maxLength="40"
                            value={formData.selectedDate}
                            onChange={(e) => setFormData(prev => ({ ...prev, selectedDate: e.target.value }))}
                            disabled={formData.files.length > 0}
                        />

                    </Col>
                    <Col sm={12} md={2} className="mb-4-sm">
                        <Button disabled={formData.files.length > 0} onClick={SearchFiles} color="success" className="btn-sm">
                            Search
                        </Button>
                    </Col>
                    <Col hidden={formData.files.length == 0} sm={12} md={6} className="mb-4-sm">
                        <DPDropDown
                            optionGroup={formData.files}
                            selectedGroup={formData.selectedFile}
                            onChange={(e) => {
                                setFormData(prev => ({ ...prev, selectedFile: e["value"] }))
                                getFileData(e["value"]);
                            }}
                            labelText={"Files"}
                        />

                    </Col>
                </Row>
                <Row hidden={formData.selectedFile == ""}>
                    <Col sm={12} md={3} className="mb-4-sm">
                        <DPTextBox
                            rowClass="mb-3-sm"
                            labelText="Search"
                            textType="text"
                            maxLength="40"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                    </Col>
                    <Col sm={12} md={2} className="mb-4-sm">
                        <Button onClick={handleSearch} color="success" className="btn-sm">
                            Search
                        </Button>
                    </Col>
                </Row>


                {/* <Button onClick={handleSearch}>Search</Button> */}
            </div>

            {/* Scrollable container for lines */}
            <div
                ref={containerRef}
                style={{
                    maxHeight: "700px",
                    overflowY: "auto",
                    fontFamily: "monospace",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    border: "1px solid #ccc",
                }}
            >
                {lines.map((line, idx) => (
                    <div
                        key={idx}
                        id={`line-${idx}`}
                        style={{ whiteSpace: "pre" }}
                    >
                        {line}
                    </div>
                ))}
            </div>
        </div>
    );


};

export default JournalViewContent;